import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import { JobOrderWorkloadResponse } from "../types/workload.type";
import { ENDPOINT } from "../endpoint";

export const GetJobWorkload = (jobOrderId: number) => {
  return {
    name: `GetJobWorkload_${jobOrderId}`,
    handle: (): Promise<JobOrderWorkloadResponse> =>
      apiCall<JobOrderWorkloadResponse>({
        url: `${ENDPOINT.JOB_ORDERS}/${jobOrderId}/workload`,
        method: HttpMethod.GET
      })
  };
};
